import newApiManager from '../NewAxiosInstance';

export const createProductComplaint = async (request: {
  productId: number;
  complaintType: string;
  productComplaintText: string;
}) => {
  const res = await newApiManager.post(`/api/v1/products/complaint/${request.productId}`, {
    complaintType: request.complaintType,
    productComplaintText: request.productComplaintText,
  });
  return res.data;
};
